// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1___df55550ea2d81d9933b","cls2":"AccountMenu-cls2__c5e6dc63a5d7b93212e7 AccountMenu-cls1___df55550ea2d81d9933b"};